<template>
	<div class="container-fluid fondo textblanco px-5" style="height:900px;">
		<div class="row">
			<div class="col-12">
				<h2 class="encabezado text-center p-5">Restablecer contraseña</h2>
			</div>
		</div>
		<div class="row d-flex justify-content-center">
			<p class="text-center">{{usuario}}</p>
		</div>

		<div class="row d-flex justify-content-center">
			<input
				:class="{ 'is-invalid': !$v.password.minLength }"
				class="form-control styletxt my-2"
				maxlength="50"
				placeholder="Contraseña"
				ref="pass"
				type="password"
				v-model="password"
			/>
		</div>
		<div class="row d-flex justify-content-center">
			<input
				:class="{ 'is-invalid': !$v.repeatPassword.sameAsPassword }"
				class="form-control styletxt my-1"
				maxlength="50"
				placeholder="Confirmar contraseña"
				type="password"
				v-model="repeatPassword"
			/>
		</div>
		<div class="row d-flex justify-content-center">
			<button @click="restablecer" class="btn ButtonGuardar my-5">Guardar nueva contraseña</button>
		</div>
	</div>
</template>

<script>
	import servicio from "@/services/servicio-publica"
	import Swal from "sweetalert2"
	import { required, sameAs, minLength } from "vuelidate/lib/validators"

	export default {
		name: "Login",
		data() {
			return {
				usuario: "",
				referencia: null,
				password: "",
				repeatPassword: ""
			}
		},
		updated() {},
		mounted() {
			this.$refs.pass.focus()
			let ref = this.$route.params.ref
			this.verificarReferencia(ref)
		},
		validations: {
			password: {
				required,
				minLength: minLength(4)
			},
			repeatPassword: {
				required,
				sameAsPassword: sameAs("password")
			}
		},
		methods: {
			restablecer() {
				if (
					this.password != "" &&
					this.$v.password.minLength &&
					this.$v.repeatPassword.sameAsPassword
				) {
					servicio
						.recuperarPasswordRestablecer(this.referencia, this.password)
						.then(r => {
							if (r.value) {
								Swal.fire({
									text: r.message,
									icon: "success"
								})
								this.$router.push("/")
							}
						})
						.catch(ex => {
							console.log(ex)
						})
				}
			},
			verificarReferencia(ref) {
				servicio
					.recuperarPasswordVerificar(ref)
					.then(r => {
						if (r.value) {
							this.usuario = r.data
							this.referencia = ref
						} else {
							this.$router.push("/")
						}
					})
					.catch(ex => {
						console.log(ex)
					})
			}
		}
	}
</script>

<style scoped>
	.ButtonGuardar {
		background: white;
		color: var(--color-azul);
		width: 300px;
	}
	.ButtonGuardar:hover {
		background: var(--color-azul);
		color: white;
		border: 1px solid white;
	}
	.fondo {
		background: var(--color-azul);
	}
	.encabezado {
		color: var(--color-blanco);
	}
	.textblanco {
		color: var(--color-blanco);
	}
	.error {
		color: yellow;
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		.styletxt {
			width: 300px;
		}
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		.styletxt {
			width: 300px;
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		.styletxt {
			width: 300px;
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
		.styletxt {
			width: 300px;
		}
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
		.styletxt {
			width: 300px;
		}
	}
</style>